import React, { useEffect } from "react"
import Layout from "components/layout/Layout";
import { ROUTES } from "utils/routes";
import { useToken } from 'lib/use-token'
import { PIANO_AUTH_CRED  } from "lib/constants"

const MailVerified = () => {

    const { setToken } = useToken();

    useEffect(() =>{
        const localToken = localStorage.getItem(PIANO_AUTH_CRED);
        setToken(localToken);
        window.location.pathname = ROUTES.DASHBOARD;
    })

    return (
        <Layout>
            <div className="flex items-start pt-32 md:pt-0 md:items-center bg-gray-50 h-screen" >
                <div className="w-full px-4 md:px-32">
                    <h1 className="text-2xl md:text-3xl text-green-500 font-bold">Your mail is verified </h1>
                    <p className="mt-8 text-left"> <a href={ROUTES.DASHBOARD} className="text-blue-500 hover:text-pblue font-medium">Go to home</a></p>
                </div>
            </div>
        </Layout>
    )
}

export default MailVerified
